import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

// Define the store's state and actions
interface PayloadState {
    payload: string | null;
    recordedUrl: string | null;
    setPayload: (payload: string | null, recordedUrl: string) => void;
    hydrated: boolean;
    setHydrated: (state: boolean) => void;
    getLatestPayload: () => { payload: string | null; recordedUrl: string | null };
}

// Create the store with persistence
export const useLatestPayloadStore = create(
    persist<PayloadState>(
        (set, get) => ({
            payload: null,
            recordedUrl: null,

            setPayload: (payload, recordedUrl) => set({ payload, recordedUrl }),

            hydrated: false,
            setHydrated: (state) => set({ hydrated: state }),

            // New getter method to always get latest values
            getLatestPayload: () => {
                const state = get();
                return {
                    payload: state.payload,
                    recordedUrl: state.recordedUrl
                };
            }
        }),
        {
            name: "latest-payload-store",
            storage: createJSONStorage(() => sessionStorage),
            onRehydrateStorage: () => (state) => {
                if (state) state.setHydrated(true);
            },
        }
    )
);